var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { tombac, Text, Button, Box, useToasts } from "tombac";
import { CopyIcon } from "tombac-icons";
import { renderProductIcon } from "../../icons";
export var ProductsApiKeys = function (_a) {
    var products = _a.products;
    return Object.entries(products).map(function (product) {
        var _a = __read(product, 2), key = _a[0], products = _a[1];
        var productsElement = products.map(function (p) { return (React.createElement("span", null,
            " ",
            renderProductIcon(p.id))); });
        return (React.createElement(Box, { "$paddingBottom": "2sp", "$marginBottom": "2sp", "$borderBottom": "1px solid ".concat(tombac.color("neutral", 300)) },
            React.createElement(Box, null, productsElement),
            React.createElement(ApiKeyField, { apiKey: key })));
    });
};
function ApiKeyField(_a) {
    var _this = this;
    var apiKey = _a.apiKey;
    var addToast = useToasts().addToast;
    var _b = __read(useState(true), 2), isMasked = _b[0], setIsMasked = _b[1];
    var apiKeyMasked = isMasked
        ? apiKey.slice(-4).padStart(apiKey.length - 4, "⦁")
        : apiKey;
    var clientApiKey = (React.createElement(React.Fragment, null,
        React.createElement(Text, { "$pt": "0.5sp", "$display": "inline-block" }, apiKeyMasked)));
    var handleCopyClick = function (apiKey) { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(apiKey)];
                case 1:
                    _a.sent();
                    addToast("The API key is copied to the clipboard", "success");
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    addToast("Failed to copy the API key to the clipboard", "danger");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Box, { "$alignItems": "center", "$display": "flex", "$gap": "1sp", className: "Product__api-key", onMouseLeave: function () { return setIsMasked(true); } },
        React.createElement(Text, { "$mt": "0.2em", as: "div", onMouseEnter: function () { return setIsMasked(false); } }, clientApiKey),
        React.createElement(Button, { onClick: function () { return handleCopyClick(apiKey); }, shape: "circle", size: "xs", variant: "flat" },
            React.createElement(CopyIcon, null))));
}
//# sourceMappingURL=ProductsApiKeys.js.map